<template>
	<div>
		<div class="body">
			<div class="body-main">
				<div class="main-head">
					<div class="level">
						<p>声望值</p>
						<p>贡献值</p>
						<p>积分值</p>
					</div>
					<div class="detail">
						<div class="detail-pic">
							<div class="image"><img src='../../assets/images/toux.png' alt=""></div>
							<div class="renzheng">已认证</div>
						</div>
						<div class="detail-content">
							<div class="top">
								<div class="username">李先生</div>
								<div style="display: flex;">
									<div class="fans guanzhu"><i class="el-icon-star-off"></i> 关注他</div>
									<div class="fans letter"><i class="el-icon-message"></i> 站内信</div>
								</div>
							</div>
							<div class="company">
								科技服务有限公司
							</div>
							<div class="jieshao">
								<p style="display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 2;
									overflow: hidden;">为人朴实正直，有积极进取的心态，努力拼搏。性格沉稳内敛，做事细心踏实，个性坚韧，能吃苦耐劳，对工作有很强的责任感！有很强进取心和团队协作精神，学习能力、适应能力、承受压力能力较强，善于挑战自我。
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="main-info">
					<div class="checkBox">
						<div @click="activeCheck = 1" :class="activeCheck == 1 ? 'checkActive':''">简历与动态</div>
						<div @click="activeCheck = 2" :class="activeCheck == 2 ? 'checkActive':''">服务产品</div>
						<div @click="activeCheck = 3" :class="activeCheck == 3 ? 'checkActive':''">平台活动</div>
					</div>
					<div class="jianli" v-show='activeCheck == 1'>
						<div class="dark-line">
							基本信息
						</div>
						<div class="main-info-userInfo">
							<div class="left">
								<div>
									<div class="title">
										<div class="tit">企业名称</div>
										<span>：</span>
										<p>海腾网络</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">注册地址</div>
										<span>：</span>
										<p>郑州市</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">成立日期</div>
										<span>：</span>
										<p>2023-05-09</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">员工人数</div>
										<span>：</span>
										<p>300</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">行政职务</div>
										<span>：</span>
										<p>主任科员</p>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">法人姓名</div>
										<span>：</span>
										<div>
											<p>杜威</p>
										</div>
									</div>
								</div>

							</div>
							<div class="right">
								<div>
									<div class="title">
										<div class="tit">邮箱</div>
										<span>：</span>
										<div>
											<p>ciwopifeng@163.com</p>
										</div>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">电话</div>
										<span>：</span>
										<div>
											<p>1833996635</p>
										</div>
									</div>
								</div>

								<div>
									<div class="title">
										<div class="tit">详细地址</div>
										<span>：</span>
										<div>
											<p>郑州市中原区广告产业园</p>
										</div>
									</div>
								</div>
								<div>
									<div class="title">
										<div class="tit">公司主页</div>
										<span>：</span>
										<div>
											<p>学术主页 http://www.baidu.com</p>
											<p>社交主页 http://www.baidu.com</p>
										</div>
									</div>
								</div>
							</div>
						</div>


						<div class="dark-line">
							企业评论
						</div>
						<div class="zhengshu">
							<div class="pinglun" v-for="(item,index) in pinglun">
								<div class="userInfo">
									<div style="width: 70px;height: 70px;border-radius: 50%;overflow: hidden;">
										<img src='../../assets/images/erciyuan.png' style="width: 100%;height: 100%;"
											alt="">
									</div>
									<p>用户昵称123123</p>
								</div>
								<div class="content">
									<p style="display: flex;color: black;">满意度：<el-rate :value="item.scroe"
											disabled></el-rate></p>
									<p style="font-size: 14px;margin-top: 10px;">{{item.data}}</p>
									<div :class="'collapse'" :style="item.collapse ?
									'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;text-overflow: ellipsis;word-break: break-all;'
									:''">
										{{item.content}}
									</div>
									<div style="float: right;cursor: pointer;margin-top: 8px;"
										v-if="item.content.length > 80" @click='item.collapse = !item.collapse'>
										<div v-if="item.collapse">展开 <i class="el-icon-caret-bottom"></i></div>
										<div v-else>收起 <i class="el-icon-caret-top"></i></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="yjandxm" v-show="activeCheck == 3">
						<div class="dark-line" style="display: flex;align-items: center;">
							接包项目<p
								style="font-size: 14px;font-weight: normal;line-height: 60px;height: 56px;margin-left: 10px;">
								(至今累计成交<span style="color: #0052D9;">100万</span>元，今年成交<span
									style="color: #0052D9;">20万</span>元)</p>
						</div>
						<div class="xmbox">
							<div class="box-item">
								<div class="title">开源海洋观测数据采集与分析</div>
								<p style="display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 3;
								overflow: hidden;">采用Web sernice方式采集台湾象局等网站发布的海洋观测数据存储到本地数据库,并利用福建NO4浮标数据与台湾马相浮标数据开展数招比对。结果表明:台湾马祁浮标与福建N04浮标观测结果相近,散点分布较为集中均匀,相关系数较高。利用202106号台风“烟花”开展同步观测分析,两浮标数据相关性较高,曲线走向也较为致。利用数据分析,有效评估了台湾海洋浮标观测数据质量
									进而说明台湾海洋浮标观测可与东海海洋浮标观测网形成有效互补。</p>
							</div>
							<div class="body-mid-footer">
								加载更多<img src='../../assets/images/darrwo.png' alt="">
							</div>
						</div>
						<div class="dark-line" style="display: flex;align-items: center;">
							发包项目<p
								style="font-size: 14px;font-weight: normal;line-height: 60px;height: 56px;margin-left: 10px;">
								(至今累计成交<span style="color: #0052D9;">100万</span>元，今年成交<span
									style="color: #0052D9;">20万</span>元)</p>
						</div>
						<div class="xmbox">
							<div class="box-item">
								<div class="title">开源海洋观测数据采集与分析</div>
								<p style="display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 3;
								overflow: hidden;">采用Web sernice方式采集台湾象局等网站发布的海洋观测数据存储到本地数据库,并利用福建NO4浮标数据与台湾马相浮标数据开展数招比对。结果表明:台湾马祁浮标与福建N04浮标观测结果相近,散点分布较为集中均匀,相关系数较高。利用202106号台风“烟花”开展同步观测分析,两浮标数据相关性较高,曲线走向也较为致。利用数据分析,有效评估了台湾海洋浮标观测数据质量
									进而说明台湾海洋浮标观测可与东海海洋浮标观测网形成有效互补。</p>
							</div>
							<div class="body-mid-footer">
								加载更多<img src='../../assets/images/darrwo.png' alt="">
							</div>
						</div>

					</div>
					<div class="hdpt" v-show="activeCheck == 2">
						<div class="dark-line">
							产品服务
						</div>
						<div style="padding: 30px 20px;">
							<el-table :data="PLtableData" stripe style="width: 100%" border="" @cell-click='clicktools'>


								<el-table-column prop="hdmc" label="编号" width="145" :resizable="false">
								</el-table-column>

								<el-table-column prop="pjz" label="名称" width="152" :resizable="false">
									<template slot-scope="scope">
										<span>{{ scope.row.pjz.slice(0, 1) + '*'.repeat( scope.row.pjz.length - 1) }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="pjnr" label="公布时间" width="465" :resizable="false">

								</el-table-column>
								<el-table-column prop="pjsj" label="关注量" width="154" :resizable="false">

								</el-table-column>
								<el-table-column prop="score" label="评分" width="162" column-key="score"
									:resizable="false">
									<template slot-scope="scope">
										<span style="color: red;">{{ scope.row.score }}</span>
									</template>
								</el-table-column>

							</el-table>

						</div>

					</div>

				</div>
			</div>
			<div class="body-right">
				<div class="cowman">
					<div class="titel">
						<img src='../../assets/images/blueZ.png' style="width: 23px;height: 21px;" alt="">
						<p>牛人推荐</p>
					</div>
					<div class="item">
						<div class="pic"><img src='../../assets/images/cowman.png' alt=""></div>
						<div style="margin-left: 10px;">
							<p style="font-weight: bold;">joy</p>
							<p style="color: #888;margin-top: 13px;font-size: 14px;">新能源研究院</p>
						</div>
					</div>
					<div class="item">
						<div class="pic"><img src='../../assets/images/cowman.png' alt=""></div>
						<div style="margin-left: 10px;">
							<p style="font-weight: bold;">joy</p>
							<p style="color: #888;margin-top: 13px;font-size: 14px;">新能源研究院</p>
						</div>
					</div>
				</div>
				<div class="cowman">
					<div class="titel">
						<img src='../../assets/images/paiming.png' style="width: 21px;height: 21px;" alt="">
						<p>排行榜</p>
					</div>
					<div class="item">
						<div class="pic"><img src='../../assets/images/cowman.png' alt=""></div>
						<div style="margin-left: 10px;">
							<p style="font-weight: bold;">joy</p>
							<p style="color: #888;margin-top: 13px;font-size: 14px;">新123123能源研究院</p>
						</div>
						<div style="color: #0052D9;font-size: 14px;margin-left: 10px;">
							3000积分
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>


</template>

<script>
	export default {
		data() {
			return {
				activeCheck: 1,
				imgUrl: [require('../../assets/images/zhengshu.png')],
				tableData2: [{
					xmfl: '资源工具',
					xkfl: '开源数据',
					hyfl: '数据调研',
					zyfl: '开源海洋观测数据采集与分析',
					fans: 33996,
					score: '4.9',
				}],
				PLtableData: [{
					hdmc: '解决方案',
					pjz: '李志远',
					pjnr: '这是个项目认为很击破，完成的很完美，赞！',
					pjsj: '2023-05-09',
					score: '4.9',
				}],
				pinglun: [{
						scroe: 3,
						data: '2023-05-31',
						content: ' 半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、云计算、人工智能等新一代信息技术的出现又为研究发展带来了新的机遇，物理模拟与数据驱动方式融合应用，为气象研究和其他领域的发展带来了无限可能性。',
						collapse: true
					},
					{
						scroe: 3,
						data: '2023-05-31',
						content: ' 半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、云计算、人工智能等新一代信息技术的出现又为研究发展带来了新的机遇，物理模拟与数据驱动方式融合应用，为气象研究和其他领域的发展带来了无限可能性。',
						collapse: true
					}
				]

			}
		},
		methods: {
			clickItem(column) {
				console.log(column)
				// this.$router.push(`/zyTools/zyQiuzDetail?id=${column.id}`)
			},
			clicktools(column) {
				// this.$router.push(`/zyTools?id=${column.id}`)
			},
		}
	}
</script>

<style scoped lang="less">
	.pinglun {
		.collapse {
			margin-top: 15px;
		}

		color: #909090;
		display: flex;
		align-items: flex-start;
		border-bottom: 1px dashed #eee;
		padding-bottom: 20px;
		margin-bottom: 30px;

		.content {
			margin-left: 28px;
			flex: 1;


			&>p {}
		}

		.userInfo {
			display: flex;
			flex-wrap: wrap;
			width: 100px;
			justify-content: flex-start;

			p {
				margin-top: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				color: black;
			}
		}
	}

	.body-mid-footer {
		width: 100%;
		margin: 0 auto;
		margin-top: 20px;
		display: flex;
		padding: 20px;
		box-sizing: border-box;
		height: 50px;
		background: #F6F6F6;
		justify-content: center;
		font-size: 18px;
		cursor: pointer;
		align-items: center;

		&>img {
			margin-left: 20px;
			width: 16px;
			height: 16px;
		}
	}

	/deep/.el-table__cell {
		color: #222222;
		text-align: center;
	}

	/deep/.el-input__inner {
		color: #222222;
	}

	/deep/.el-input__inner::placeholder {
		color: black !important;
	}

	/deep/.el-table th.el-table__cell.is-leaf {
		background: #E5EDFB;
		color: #222222;
		border: 1px solid white;
		border-top: none;
	}

	.body {
		padding-top: 20px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		.yjandxm {
			.xmbox {
				padding: 20px;

				.box-item {
					border-bottom: 1px dashed #E5E5E5;

					.title {
						font-size: 18px;
						font-weight: bold;
						margin-bottom: 20px;
					}

					p {
						color: #888;
						line-height: 24px;
						font-size: 15px;


					}

					padding: 20px 0;
				}
			}

			.body-mid-footer {
				margin-top: 30px;
				display: flex;
				padding: 20px;
				box-sizing: border-box;
				height: 50px;
				background: #F6F6F6;
				justify-content: center;
				font-size: 18px;
				cursor: pointer;
				align-items: center;

				&>img {
					margin-left: 20px;
					width: 16px;
					height: 16px;
				}
			}
		}

		.body-right {
			width: 260px;
			height: 535px;

			.cowman {
				margin-bottom: 20px;
				background: #FFFFFF;

				.item {
					display: flex;
					align-items: center;
					border-bottom: 1px dashed #EBEBEB;
					padding: 20px;
					box-sizing: border-box;
					padding-right: 5px;

					p {
						width: 90px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.pic {
						width: 54px;
						height: 54px;
						overflow: hidden;
						border-radius: 50%;

						img {
							width: 100%;
							height: 100%;
						}
					}
				}

				.item:last-child {
					border: none;
				}
			}

			.titel {
				height: 60px;
				display: flex;
				background: #E5EDFB;
				font-weight: bold;
				font-size: 18px;
				align-items: center;
				padding-left: 15px;

				p {
					margin-left: 5px;
				}
			}
		}

		.body-main {
			.main-info {
				background: #FFFFFF;
				margin-top: 20px;

				.jianli {
					.zhengshu {
						display: flex;
						flex-wrap: wrap;
						padding: 30px 30px;

						.img {
							display: flex;
							justify-content: center;
							margin-right: 40px;
							margin-bottom: 30px;
						}
					}

					.goodfor {
						p {
							font-weight: bold;
						}

						.good-item {
							margin-top: 20px;
							display: flex;

							div {
								background: #E5EDFB;
								padding: 0 20px;
								margin-right: 15px;
								height: 35px;
								line-height: 35px;
								color: #0052D9;
								text-align: center;
							}
						}
					}

					.beishu {
						padding: 35px 30px;
						box-sizing: border-box;

						.beishu-item {
							display: flex;
							align-items: center;
						}

						.dian {
							display: inline-block;
							width: 5px;
							height: 5px;
							border-radius: 50%;
							background: #0052D9;
						}

						.beishuPerson {
							color: #888;
							display: flex;
							align-items: center;
							margin: 25px 0;
							font-size: 14px;

							&>div {
								margin-right: 66px;
							}

							span {
								margin-left: 10px;
							}

							.dian {
								background-color: #888;
							}
						}
					}

				}

				.main-info-userInfo {
					display: flex;

					.left,
					.right {
						width: 50%;

						.title {
							margin-bottom: 15px;

							p {
								color: black;
								margin-left: 60px;
								margin-bottom: 15px;
							}

							display: flex;

							.tit {
								width: 78px;
								text-align: justify;
								text-align-last: justify;
							}

							color: #888888;
						}
					}

					padding:40px 20px;
					padding-bottom: 0px;
					box-sizing: border-box;
				}

				.dark-line {
					background: #F2F6FD;
					font-weight: bold;
					height: 56px;
					font-size: 18px;
					line-height: 56px;
					padding-left: 20px;
				}

				.checkBox {
					padding: 0 20px;
					font-size: 18px;
					display: flex;
					height: 80px;
					line-height: 80px;
					cursor: pointer;

					div {
						margin-right: 60px;
					}

					.checkActive {
						font-weight: bold;
						color: #0052D9;
						border-bottom: 3px solid #0052D9;
					}
				}
			}

			.main-head {
				background: #fff;

				.detail {
					display: flex;
					width: 100%;

					.detail-content {
						height: 100%;
						padding: 20px 20px 10px 0;
						flex: 1;

						.jieshao {
							margin-top: 10px;
							font-family: PingFang;
							font-weight: 400;
							color: #888888;
							line-height: 25px;

						}

						.company {
							margin-top: 5px;
							display: inline-block;
							padding: 0 10px;
							height: 29px;
							background: #E5EDFB;
							color: #0052D9;
							text-align: center;
							font-size: 14px;
							line-height: 29px;
						}

						.top {
							display: flex;
							justify-content: space-between;
							height: 40px;
							align-items: center;

							.username {
								font-size: 20px;
								font-weight: bold;
							}

							.letter {
								background: #FBF4E5;
								color: #D99D0E;
							}

							.guanzhu {
								background: #E5EDFB;
								color: #0052D9;
							}

							.fans {
								cursor: pointer;
								line-height: 38px;
								text-align: center;
								margin-left: 25px;
								width: 108px;
								height: 38px;
								border-radius: 2px;

								i {
									font-size: 18px;
									line-height: 20px;
								}
							}
						}
					}

					.detail-pic {
						width: 150px;
						flex-wrap: wrap;
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						padding-bottom: 10px;
						box-sizing: border-box;

						.image {
							width: 100px;
							height: 100px;
							overflow: hidden;
							border-radius: 50%;

							img {
								width: 100%;
								height: 100%;
							}
						}

						.renzheng {
							cursor: pointer;
							color: #222222;
							text-align: center;
							line-height: 33px;
							width: 83px;
							height: 33px;
							background: #EEEEEE;
						}
					}
				}

				display: flex;

				.level {
					width: 142px;
					height: 168px;
					background: #0052D9;
					padding: 20px;
					box-sizing: border-box;
					color: white;
					padding-top: 35px;

					p {
						margin-bottom: 12px;
						font-size: 18px;
						font-family: PingFang;
						font-weight: bold;
					}
				}
			}

			width: 1120px;
		}

	}
</style>